import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BarbarianFuryGameConfig} from "../BarbarianFuryGameConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {BarbarianFury} from "../BarbarianFury";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {TimelineLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {BarbarianFuryBigWinCountUp} from "./bigwin/BarbarianFuryBigWinCountUp";

export class BarbarianIndividualWinSymCombController extends WinPresentationController {
    protected _gameData: ParsedGameData | null;
    private _layer: ScalableLayer;
    private _mainTL: TimelineLite | null;
    private _isFinishedAlreadyCalled = false;

    constructor(indexes: [number, number]) {
        super(indexes, {
            name: "BarbarianFury",
            betWinMode: BetWinMode.BET_LINE,
            skippable: true
        });
        this._layer = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.INDIVIDUAL_WIN_SYM_COMB.name);
    }

    protected hasWin(): boolean {
        if (this._gameData && BarbarianFury.api.gameClientConfiguration.displayIndividualWinsInGame) {
            return this._gameData?.betWins?.length > 1;
        } else {
            return false
        }
    }

    protected startWinPresentation(): void {
        let betWins: IBetLineWinData[] | undefined = this._gameData?.betWins ? (<IBetLineWinData[]>(this._gameData?.betWins as unknown)) : undefined;
        const mainTl: TimelineLite = new TimelineLite();
        let sourceFPS: number = 50;
        this._isFinishedAlreadyCalled = false;
        if (betWins) {
            if (betWins.length < 10) {
                sourceFPS = 50;
            } else if (betWins.length < 20) {
                sourceFPS = 80;
            } else {
                sourceFPS = 100;
            }
            for (let i: number = 0; i < betWins?.length; i++) {
                const indiBetWinData: IBetLineWinData = betWins[i],
                    indiTL: TimelineLite = new TimelineLite();
                let lastWinSym: number[] = [];
                for (let j: number = 0; j < indiBetWinData.nrOfSymbols; j++) {
                    let symbol_anim: TimelineSprite | null = new TimelineSprite(GameResources.getTextures("BetLineBoxAnimation"), sourceFPS);
                    symbol_anim.scale.set(2);
                    symbol_anim.anchor.set(0.5);
                    symbol_anim.blendMode = PIXI.BLEND_MODES.ADD;
                    symbol_anim.position.set(Helper.getSymbolPositions(j, indiBetWinData.betLine[j])[0], Helper.getSymbolPositions(j, indiBetWinData.betLine[j])[1]);
                    symbol_anim.visible = false;
                    this._layer.addChild(symbol_anim);
                    indiTL.add(symbol_anim.getAnimationAutoShowHide(true, true), 0);
                    lastWinSym = [j, indiBetWinData.betLine[j]];

                }
                const winAmount: BarbarianFuryBigWinCountUp = new BarbarianFuryBigWinCountUp(10);
                winAmount.createCountUpIndividualWinSymCombController();
                winAmount.visible = false;
                winAmount.getCountUpAnimation(0, indiBetWinData.multipliedAmount, 0.001).progress(1);
                winAmount.position.set(Helper.getSymbolPositions(lastWinSym[0], lastWinSym[1])[0], Helper.getSymbolPositions(lastWinSym[0], lastWinSym[1])[1]);
                this._layer.addChild(winAmount);
                indiTL.add(() => {
                    winAmount.visible = true;
                }, 0);
                indiTL.add(() => {
                    winAmount.visible = false;
                })
                mainTl.add(indiTL);
            }
        }
        mainTl.add(() => {
            this._layer.removeChildren();
            this.finish();
        })
        if (this._mainTL) {
            this._mainTL = null;
        }
        this._mainTL = mainTl;
    }

    protected stopWinPresentation(isAborted: boolean) {
        if (isAborted) {
            if (this._mainTL) {
                this._mainTL.progress(1);
            }
        }
        if (this._mainTL) {
            this._mainTL = null;
        }
    }

    protected finish(isAborted?: boolean) {
        if (this._isFinishedAlreadyCalled) {
            return;
        }
        if (!this._isFinishedAlreadyCalled) {
            this._isFinishedAlreadyCalled = true;
        }
        super.finish(isAborted);
    }
}